/**
 * Do not remove any keys!!
 * The shape of this file is to remain the same so that all options are know.
 *
 * If a key does not have a value, set the value to undefined.
 */
module.exports = {
  communityName: "Shamrock Apartments",
  gtagId: "G-D36361KFYS",
  logo: {
    src: "https://cdn.maxxpm.com/shamrock/shamrock_logo.png",
    alt: "Shamrock Logo",
  },
  nav: {
    bannerSubtitle: undefined,
    bannerTitle: undefined,
    bannerCTA: undefined,
  },
  footer: {
    address: "1590 N Shamrock St.",
    cityStateZip: "Boise, ID 83713",
    phone: "(208) 609-3932",
    copyrightYear: "2025",
    logo: "https://cdn.maxxpm.com/shamrock/shamrock_logo.png",
  },
  listMarkerSrc: "https://cdn.maxxpm.com/shamrock/shamrock_icon.png",
  hasShowingPopup: true,
  home: {
    banner: {
      image: "https://cdn.maxxpm.com/shamrock/boise-3864184_150.jpg",
      video: "https://cdn.maxxpm.com/shamrock/Master_Shamrock_Drone_002.mp4",
      title: "Live Where Life Happens",
      subtitle: "Minutes from everything you love in Boise and Meridian",
      openHouse: {
        start: new Date("2024-12-02T10:00:00.000-06:00"),
        end: new Date("2024-12-02T14:00:00.000-06:00"),
        image: "https://cdn.maxxpm.com/abingtonheights/Abington Website Photos/1.jpg",
      },
    },
    aboutUs: {
      paragraphs: [
        "Located in Boise, just minutes from Meridian, Shamrock Apartments offers the perfect blend of suburban charm and urban accessibility. Whether you're drawn to the vibrant energy of downtown Boise or the growing conveniences of Meridian, our location provides easy access to both.",
        "Residents enjoy proximity to top local attractions, including Albertsons Market Place, Julius M. Kleiner Memorial Park, The Village at Meridian, local farmers' markets, and popular restaurants are just a short drive away. Plus, with downtown Boise only 15 minutes away and downtown Meridian just 10 minutes away, you're never far from entertainment, cultural experiences, and business hubs.",
        "With modern amenities and a prime location close to everything you need, Shamrock Apartments offers a comfortable and convenient living experience in the heart of the Treasure Valley.",
      ],
      image: {
        src: "https://cdn.maxxpm.com/shamrock/b7550007-9632-4f23-8e65-ba740bd376be.jpeg",
        alt: "Boise, Idaho",
      },
    },
    floorplanTitle: "Explore Our Floor Plan and Take a 3D Virtual Tour",
    floorplans: [
      {
        hasImage: true,
        image: {
          src: "https://cdn.maxxpm.com/shamrock/pr_fp (1).png",
          alt: "Apartment Floor Plan",
        },
        hasWalkthrough: true,
        walkthrough: {
          src: "https://my.matterport.com/show/?m=gVRXMZvQz7P",
          title: "3D Walkthrough",
        },
      },
    ],
    midContainerImage: "https://cdn.maxxpm.com/shamrock/8ba359d9-63b9-41bb-b5b0-248d22971886.jpeg",
    imgRow: [
      {
        src: "https://cdn.maxxpm.com/shamrock/hd_photos/06-1556Shamrock-6.jpg",
        alt: "Shamrock Playground",
      },
      {
        src: "https://cdn.maxxpm.com/shamrock/hd_photos/11-1556Shamrock-11.jpg",
        alt: "Shamrock Living Room",
      },
      {
        src: "https://cdn.maxxpm.com/shamrock/hd_photos/07-1556Shamrock-7.jpg",
        alt: "Shamrock Dog Park",
      },
    ],
    animalPolicy: {
      img: {
        src: "https://cdn.maxxpm.com/shamrock/39b0a207-6a04-426c-a592-1ed6e35fd1de.jpeg",
        alt: "Animal policy stock photo",
      },
      policies: [
        "No more than 2 animals are allowed per property",
        "Cats/Dogs: $250/animal*",
        "$50/animal/month for animals under 50lbs*",
        "$75/animal/month for animals 50lbs+*",
        "One-time $65/animal DNA testing fee*",
        "Caged animals: $25/animal/month*",
        "Fish tanks are not permitted",
        "Small, caged mammals are not permitted, including but not limited to: rats, mice, hamsters, rabbits, guinea pigs, ferrets, sugar gliders, and hedgehogs",
      ],
      breedRestrictions: ["Pit Bulls & Staffordshire Terriers", "Doberman Pinschers", "Rottweilers", "Chows", "Great Danes", "Presa Canarios/ Mastiffs", "Akitas", "Alaskan Malamutes", "Huskies", "German Shepherds", "Shar Peis", "Wolf-Hybrids"],
    },
  },
  availability: {
    banner: {
      image: "https://cdn.maxxpm.com/shamrock/hd_photos/33-1556Shamrock-33.jpg",
      video: undefined,
      title: "Available Units",
      subtitle: "Unit availability is updated often from Monday-Friday during business hours. Evenings and weekends may not reflect accurate availability dates.",
    },
    hasWaitingList: true,
    waitingListJotformId: "250436787185164",
    propertyGroup: "LEADS-SA",
  },
  faq: {
    banner: {
      image: "https://cdn.maxxpm.com/shamrock/hd_photos/12-1556Shamrock-12.jpg",
    },
    dnaRequired: true,
  },
};
